var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "period-selection-container" }, [
    _c("label", { staticClass: "color-black font-18 mt-1 mr-3" }, [
      _vm._v("Periodo:")
    ]),
    _c(
      "div",
      {
        staticClass: "period-selection-container__section",
        class: [{ finalized: this.completedPeriod }]
      },
      _vm._l(_vm.getPeriods, function(p, index) {
        return _c(
          "div",
          {
            key: "period-selection" + index,
            staticClass: "period-selection-container__period",
            class: [
              {
                disabled:
                  (p.disabled && !p.completed && !p.active) ||
                  _vm.evalDisabledRegularPeriod(p.id),
                completed: p.completed,
                active: p.active && !p.completed
              }
            ],
            on: {
              click: function($event) {
                return _vm.onSelectPeriodHandler(p)
              }
            }
          },
          [
            _c(
              "span",
              { staticClass: "d-block color-gray-7 font-14 font-weight-bold" },
              [_vm._v(" " + _vm._s(p.month) + " ")]
            ),
            _c("span", { staticClass: "color-gray-7 font-14" }, [
              _vm._v(" " + _vm._s(p.year) + " ")
            ]),
            p.completed
              ? _c("div", { staticClass: "period-finish" }, [
                  p.completed
                    ? _c(
                        "div",
                        {
                          staticClass: "dot cursor-pointer green",
                          on: {
                            click: function($event) {
                              _vm.extraExpanded = !_vm.extraExpanded
                            }
                          }
                        },
                        [_c("em", { staticClass: "title-icon fa fa-check" })]
                      )
                    : _vm._e(),
                  _c("span", [_vm._v("Periodo Finalizado")])
                ])
              : _vm._e()
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }